import { render } from "./WriteCompositionApi.vue?vue&type=template&id=105e54d6"
import script from "./WriteCompositionApi.vue?vue&type=script&lang=ts"
export * from "./WriteCompositionApi.vue?vue&type=script&lang=ts"
script.render = render

export default script